import {
  EventService_SearchEvents,
  type SearchEventsRequest,
  type SearchEventsResponse,
} from '@src/gen/ai/h2o/audittrail/v1/event_service_pb';
import { fetchWrapRPC } from '@shared/services/appstore/api';

export class AuditTrailServiceImpl {
  private basePath: string;
  constructor(basePath?: string) {
    this.basePath = basePath || '';
  }

  public setBasePath = (path: string) => {
    this.basePath = path;
  };

  public async searchEvents(
    req: SearchEventsRequest,
    requestInit?: { signal?: AbortSignal }
  ): Promise<SearchEventsResponse> {
    return await fetchWrapRPC(EventService_SearchEvents, { basePath: this.basePath })({ ...req }, requestInit);
  }
}
